<template>
    <base-detail 
        ref="detail"
        class="product-remains-detail"
        v-bind:title="$filters.localize('ProductRemainsDetail.caption')"
        v-bind:rootId="rootId" 
        v-bind:rootColumn="rootColumn"
        v-bind:schemaName="'productremains'"
        v-bind:headers="headers"
        v-bind:entity="entity"
        v-bind:lookups="lookups"
        v-bind:disableOpenClose="'true'"
        v-bind:before-save="beforeSave"
        v-on:main-save="main-save"
        v-on:on-parrent-load="on-parrent-load">
        <template v-if="entity.productId" v-slot="{entity, save, rows}" class="input-group">
            <form 
                v-on:submit.prevent="saveRemain(entity, save)" 
                class="input-group mb-3 detail-add-form">
                <div
                    class="detail-add-form__field detail-add-form__quantity detail-add-form__field--floating"
                    :class="{ 'detail-add-form__field--filled': entity.quantity !== null && entity.quantity !== '' }">
                    <label class="detail-add-form__label">{{
                        $filters.localize('main.countTitle')
                    }}</label>
                    <input
                        class="form-control detail-add-form__control"
                        type="number"
                        min="0"
                        v-model="entity.quantity"
                        required>
                </div>
                <div
                    class="detail-add-form__field detail-add-form__size detail-add-form__field--floating"
                    :class="{ 'detail-add-form__field--filled': !!entity.characterId }">
                    <label class="detail-add-form__label">{{
                        $filters.localize('main.size')
                    }}</label>
                    <select
                        class="form-control detail-add-form__control"
                        v-model="entity.characterId"
                        required>
                        <option value="" disabled selected></option>
                        <option v-for="option in lookups.characters.filter(item => rows.filter(x=> x.characterId == item.id) == 0)"
                            v-bind:key="option.id" 
                            :value="option.id">
                                {{ option.name }}
                        </option>
                    </select>
                </div>
                <label
                    class="form-control detail-add-form__toggle"
                    v-if="productIsTailoringAvailable">
                    <input
                        class="mr-2"
                        type="checkbox"
                        v-model="entity.isTailoringAvailable">
                    {{ $filters.localize('ProductPage.fields.isTailoringAvailable') }}
                </label>
                <button :disabled="!enabled"
                    class="btn btn-primary detail-add-form__submit" 
                    type="submit">{{ $filters.localize('button.add') }}</button>
            </form>
        </template>
    </base-detail>
</template>

<script>
import BaseDetail from '@/components/Sections/BaseDetail.vue';
export default {
    name: "ProductRemainsDetail",
    components:{ BaseDetail },    
    emits:["on-parrent-load","main-save"],
    props:{
        rootId: { type:String, require:true },
        rootColumn: { type:String, require:true },
        enabled: { type: Boolean},
        productIsTailoringAvailable: { type: Boolean}
    },
    computed: {
        headers() {
            const headers = [
                { field:"characterId", name:this.$filters.localize('main.size'), sort:true, lookup:"characters", enabeled: false },
                { field:"quantity", name:this.$filters.localize('main.countTitle'), sort:true, input: { type: "numeric" }, enabeled: true}
            ];

            if (this.productIsTailoringAvailable) {
                headers.push({
                    field:"isTailoringAvailable",
                    name:this.$filters.localize('ProductPage.fields.isTailoringAvailable'),
                    sort:true,
                    input: { type: "checkbox" },
                    enabeled: true
                });
            }

            return headers;
        }
    },
    watch: {
        rootId(value) {
            this.entity.productId = value;
        },
        productIsTailoringAvailable(value) {
            if (value) return;

            this.entity.isTailoringAvailable = false;
        }
    },
    methods:{
        loadLookups() {
            this.$store.dispatch('section', { table: "productcharacter" })
            .then((response) => {
                this.lookups.characters = response.data.data;
            });
        },
        disableTailoringAvailability() {
            this.entity.isTailoringAvailable = false;
            if (!this.rootId) return;

            this.$refs.detail?.loadRows();
        },
        async saveRemain(entity, save) {
            if (!this.productIsTailoringAvailable)
                entity.isTailoringAvailable = false;

            await save(entity);
        },
        async beforeSave(entity) {
            if (!this.productIsTailoringAvailable) {
                entity.isTailoringAvailable = false;
                return;
            }

            await new Promise((resolve, reject) => {
                this.$emit("main-save", null, resolve, reject, { silent: true });
            });
        }
    },
    mounted(){
        this.loadLookups();
    },
    data(){
        return {
            lookups:{
                characters:[]
            },
            entity:{
                characterId:"",
                productId:this.rootId,
                quantity:"",
                isTailoringAvailable:false,
            }
        };
    }
}
</script>

<style scoped>
.detail-add-form {
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0;
  position: relative;
  z-index: 20;
  width: 100%;
}

.product-remains-detail {
  height: 100%;
  min-height: 0;
  margin-bottom: 0;
}

.product-remains-detail :deep(.detail-card__body) {
  height: calc(100% - 41px);
  min-height: 0;
  overflow: hidden;
}

.product-remains-detail :deep(.detail-table-wrap) {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow: auto;
}

.detail-add-form__field {
  flex: 1 1 0;
  min-width: 0;
  height: 36px;
  min-height: 36px;
  position: relative;
}

.detail-add-form__field + .detail-add-form__field,
.detail-add-form__toggle,
.detail-add-form__submit {
  margin-left: -1px;
}

.detail-add-form__field:focus-within,
.detail-add-form__control:focus {
  z-index: 2;
}

.detail-add-form__label {
  margin: 0;
  color: #7b8794;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
}

.detail-add-form__field--floating .detail-add-form__label {
  position: absolute;
  top: 50%;
  left: 12px;
  z-index: 3;
  max-width: calc(100% - 24px);
  overflow: hidden;
  transform: translateY(-50%);
  transition: top 0.14s ease, transform 0.14s ease, font-size 0.14s ease, color 0.14s ease;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-add-form__field--floating:focus-within .detail-add-form__label,
.detail-add-form__field--floating.detail-add-form__field--filled .detail-add-form__label {
  top: 6px;
  transform: none;
  color: #4f7fa7;
  font-size: 0.58rem;
  text-transform: uppercase;
}

.detail-add-form__control {
  width: 100%;
  height: 36px;
  min-height: 36px;
  border-color: #ced4da;
  border-radius: 0;
  position: relative;
}

.detail-add-form__field--floating .form-control.detail-add-form__control {
  padding: 14px 12px 2px;
}

.detail-add-form__size.detail-add-form__field--filled .detail-add-form__control {
  padding-top: 12px;
  padding-bottom: 0;
  line-height: 1.2;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control {
  color: transparent;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control option {
  color: #495057;
}

.detail-add-form__quantity {
  min-width: 120px;
}

.detail-add-form__size {
  min-width: 140px;
}

.detail-add-form__quantity .detail-add-form__control {
  border-radius: 0.25rem 0 0 0.25rem;
}

.detail-add-form__toggle {
  flex: 1 1 220px;
  display: flex;
  align-items: center;
  width: auto;
  height: 36px;
  min-height: 36px;
  margin-bottom: 0;
  padding: 6px 12px;
  border-color: #ced4da;
  border-radius: 0;
  color: #495057;
  font-size: 0.875rem;
  line-height: 1.2;
  white-space: nowrap;
}

.detail-add-form__toggle input {
  flex: 0 0 auto;
}

.detail-add-form__submit {
  flex: 0 0 auto;
  height: 36px;
  min-height: 36px;
  padding-inline: 1rem;
  white-space: nowrap;
  border-radius: 0 0.25rem 0.25rem 0;
  position: relative;
  z-index: 1;
}

.detail-add-form__size:last-of-type .detail-add-form__control {
  border-radius: 0;
}

.detail-add-form__field:nth-last-child(2) .detail-add-form__control {
  border-radius: 0;
}

@media (max-width: 576px) {
  .product-remains-detail {
    height: auto;
    min-height: 0;
  }

  .product-remains-detail :deep(.detail-card__body) {
    height: auto;
    min-height: 0;
    overflow: visible;
  }

  .product-remains-detail :deep(.detail-table-wrap) {
    flex: 0 0 auto;
    max-height: none;
    overflow-x: auto;
    overflow-y: visible;
  }

  .detail-add-form {
    gap: 0.5rem;
  }

  .detail-add-form__field,
  .detail-add-form__toggle,
  .detail-add-form__submit,
  .detail-add-form__control {
    flex-basis: 100%;
    width: 100%;
    margin-left: 0;
    border-radius: 0.25rem;
  }
}
</style>
